import * as React from 'react'

export function MicrosoftIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" {...props}>
			<rect x="1" y="1" width="9" height="9" fill="#f25022" />
			<rect x="11" y="1" width="9" height="9" fill="#7fba00" />
			<rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
			<rect x="11" y="11" width="9" height="9" fill="#ffb900" />
		</svg>
	)
}

export function GoogleIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				fill="#4285F4"
				d="M23.766 12.276c0-.818-.074-1.606-.213-2.364H12.24v4.475h6.482a5.54 5.54 0 0 1-2.4 3.633v3.02h3.883c2.274-2.093 3.561-5.176 3.561-8.764z"
			/>
			<path
				fill="#34A853"
				d="M12.24 24c3.24 0 5.956-1.075 7.941-2.91l-3.883-3.02c-1.078.723-2.46 1.15-4.058 1.15-3.12 0-5.76-2.106-6.705-4.938H1.518v3.115C3.492 21.31 7.532 24 12.24 24z"
			/>
			<path
				fill="#FBBC05"
				d="M5.535 14.282a7.19 7.19 0 0 1 0-4.564V6.603H1.518a11.99 11.99 0 0 0 0 10.794l4.017-3.115z"
			/>
			<path
				fill="#EA4335"
				d="M12.24 4.77c1.762 0 3.344.607 4.588 1.795l3.442-3.442C18.192 1.19 15.476 0 12.24 0 7.532 0 3.492 2.69 1.518 6.603l4.017 3.115c.945-2.832 3.585-4.938 6.705-4.938z"
			/>
		</svg>
	)
}
